import moment from "moment";
import { ZeroAmount } from "../Const";
import { eligibleBots } from "../actions/const";

export const AGENTIC_AI_PI4_DAY_TRADER_TEMPLATE_ID = 30;
const LOCKED_DAY_TRADER_TEMPLATE_IDS = [
  AGENTIC_AI_PI4_DAY_TRADER_TEMPLATE_ID,
  31,
];

export const capitalize = (text) => {
  return (text && text.charAt(0).toUpperCase() + text.slice(1)) || "";
};

export const formatNumberToString = (num, decimal = 8) => {
  if (!num) return ZeroAmount;
  return num.toFixed(decimal);
};

export const roundNumber = (num, scale) => {
  var scale = scale || scaleNumber(num);
  if (!("" + num).includes("e")) {
    return +(Math.round(num + "e+" + scale) + "e-" + scale);
  } else {
    var arr = ("" + num).split("e");
    var sig = "";
    if (+arr[1] + scale > 0) {
      sig = "+";
    }
    return +(
      Math.round(+arr[0] + "e" + sig + (+arr[1] + scale)) +
      "e-" +
      scale
    );
  }
};

export const scaleNumber = (num) => {
  if (num == 0) return 0;
  const scale = 4 - Math.floor(Math.log10(Math.abs(num)));
  return scale < 1 ? 1 : scale;
};

export const formatDate = (
  dateString,
  from = "YYYY-MM-DD HH:mm:ss",
  to = "DD MMM YYYY"
) => {
  const timezone = localStorage.getItem("timezone");
  const date = moment.utc(dateString, from);
  return timezone
    ? date.utcOffset(timezone).format(to)
    : date.local().format(to);
};
export const formatDateTime = (
  dateString,
  from = "YYYY-MM-DD HH:mm:ss",
  to = "DD MMM YYYY HH:mm:ss"
) => {
  const timezone = localStorage.getItem("timezone");
  const date = moment.utc(dateString, from);
  return timezone
    ? date.utcOffset(timezone).format(to)
    : date.local().format(to);
};
export const formatDateMinute = (
  dateString,
  from = "YYYY-MM-DD HH:mm",
  to = "DD MMM YYYY HH:mm"
) => {
  const timezone = localStorage.getItem("timezone");
  const date = moment.utc(dateString, from);
  return timezone
    ? date.utcOffset(timezone).format(to)
    : date.local().format(to);
};

export const milisecOf = (dateString, format = "YYYY-MM-DD HH:mm:ss") => {
  const date = moment.utc(dateString, format);
  return date.valueOf();
};

export const compareDate = (date1, date2) => {
  return moment(date1).isBefore(date2);
};

export const dayTillNow = (dateString, format = "YYYY-MM-DD HH:mm:ss") => {
  const date = moment.utc(dateString, format);
  const ms = moment().diff(date);
  return normalizeTime(ms);
};

export const getCurrentTimeZone = () => {
  const offset = moment().utcOffset();
  const min = offset % 60;
  const absMin = Math.abs(min);
  const hour = (offset - min) / 60;
  const absHour = Math.abs(hour);
  return `${hour < 0 ? "-" : "+"}${absHour < 10 ? "0" + absHour : absHour}:${
    absMin < 10 ? "0" + absMin : absMin
  }`;
};

export const normalizeTime = (ms) => {
  const day = ms / 1000 / 60 / 60 / 24;
  return { time: day, unit: "D" };
};

export const decimalOf = (coin) => {
  const lowerCase = coin.toLowerCase();
  return lowerCase === "btc" ? 6 : lowerCase.includes("usd") ? 2 : 4;
};

export const normalizeNumber = (num) => {
  const numString = String(num) || "0";
  return parseFloat(numString.replace(",", ".")) || 0;
};

export const typeNameOrder = (type) => {
  switch (type.toLowerCase()) {
    case "de":
      return "Liquidated";
    case "bo":
      return "Base Order";
    case "eo":
      return "Extra Order";
    case "tp":
      return "Take Profit";
    case "sl":
      return "Stoploss";
    case "ie":
      return "Indicator Exit";
    default:
      return "Order";
  }
};

export const orderSide = (type, isLong) => {
  
  const lowerCaseType = type.toLowerCase();
  if (
    (isLong && ["bo", "eo"].includes(lowerCaseType)) ||
    (!isLong && ["de", "sl", "tp","ie"].includes(lowerCaseType))
  )
    return "Buy";
  return "Sell";
};

export const getResource = (path) => {
  const components = path && path.split("/");
  return (
    components && components.length > 1 && components[components.length - 1]
  );
};

export const divZeroable = (a, b) => {
  return b == 0 ? 0 : a / b;
};

export const isLong = (strategy) => {
  if (!strategy) return true;
  return strategy.toLowerCase() === "long";
};
export const isMarginShort = (strategy) => {
  if (!strategy) return true;
  return strategy.toLowerCase() === "margin short";
};

export const hideEmail = (email) => {
  if (!email) return "************";
  const firstChar = email[0];
  return firstChar + "***********";
};

export const getKeyByValue = (object, value) => {
  return Object.keys(object).find((key) => object[key] === value);
};

export const getMonthDay = (day) => {
  switch (day) {
    case 1:
    case 21:
    case 31:
      return day + "st";
    case 2:
      return "2nd";
    case 3:
      return "3rd";
    default:
      return day + "th";
  }
};
export const  restrictAlphabets = (e)=>{
  var x = e.which || e.keycode;
  if(!(x>=46 && x<=57))
    e.preventDefault()
}
export const trimString = (str,length)=>{
  return str.length > length ? str.substring(0, length) + "..." : str;
}
export const currencyFormat = (number,decimal=3)=>{
  return new Intl.NumberFormat(undefined,{
    minimumFractionDigits: decimal,
    maximumFractionDigits: decimal
  }).format(number)
}
export const eligibleExtendedHours = (selectedExchange)=>{
  const exchangeIds = [0,1,2,4,16,17,12,13,14,40,41,400,4000,202,204,205];
  return selectedExchange?.extended_trading_hour_available
    ?? exchangeIds.includes(selectedExchange?.id);
}
export const getRentBotTemplateId = (rentBot = {}) => {
  return Number(
    rentBot?.template_id ??
      rentBot?.rental?.template?.id ??
      rentBot?.rental?.template_id ??
      rentBot?.template?.id ??
      0
  );
}
export const isLockedDayTraderTemplate = (rentBot = {}) => {
  const templateTitle = String(
    rentBot?.rental?.template?.title ??
      rentBot?.template?.title ??
      rentBot?.template_name ??
      ""
  ).toLowerCase();

  return (
    LOCKED_DAY_TRADER_TEMPLATE_IDS.includes(getRentBotTemplateId(rentBot)) ||
    templateTitle.includes("agentic ai pi4 day trader")
  );
}
export const eligibleMaxContracts = (selectedExchange)=>{
  const exchangeIds = [18];
  return exchangeIds.includes(selectedExchange.id)
}
export const eligible24dHours = (selectedExchange)=>{
  const exchangeIds = [0,1,6,12,100,202,204];
  return selectedExchange?.trading_hour_247_available
    ?? exchangeIds.includes(selectedExchange?.id);
}
export const disableFractionExchanges = (selectedExchange)=>{
  const exchangeIds = [1,2,4,5,8,11,12,14,15,100,200,140];
  return selectedExchange?.disable_fractional_purchase_available
    ?? exchangeIds.includes(selectedExchange?.id);
}
export const eligibleResetCompletedPaperTrades = (selectedExchange)=>{
  const exchangeIds = [0,100];
  return exchangeIds.includes(selectedExchange.id)
}

export const serverDateFormat = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based, so we add 1
  const day = String(date.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
};

export const getCurrencySymbol = (selectedExchangeId,currency) => {
  if (!selectedExchangeId) return "$";
  return currency?currency.symbol:"$";
}

export const isInr = (selectedExchange) => {
  return selectedExchange === 1000;
};
